export enum CountryCode {
    "English" = 'en',
    "French" = 'fr',
    "German" = 'de',
    "UnitedStates" = 'us'
}

export function getCountryCode(code: string): CountryCode | undefined {
    const returnValue = Object.entries(CountryCode).find(([_key, value]) => value === code)
    return returnValue?.[1];
}